var map = {
	"./food_0.png": 7972,
	"./food_1.png": 5566,
	"./food_10.png": 8636,
	"./food_11.png": 2062,
	"./food_12.png": 1482,
	"./food_2.png": 2696,
	"./food_3.png": 5658,
	"./food_4.png": 5063,
	"./food_5.png": 144,
	"./food_6.png": 5738,
	"./food_7.png": 7001,
	"./food_8.png": 8588,
	"./food_9.png": 5108,
	"./food_undefined.png": 1674
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9987;